<template>
  <el-card shadow="never">
    <el-row class="dormitory-main"
            :gutter="15">
      <el-col class="building-main"
              :span="3"
              :sm="3"
              :xs="12">
        <p class="item-title">楼宇机构</p>
        <div class="building-item"
             :class="getBuildingClass(item, index)"
             v-for="(item, index) in dormitoryData"
             :key="index"
             :title="item.name"
             @click="changeBuilding(item, index)">
          <i class="el-icon-office-building mr-5"></i>
          <span>{{item.name}}</span>
          <p :title="item.no + '/' + item.yes">
            （ <span class="txt-red">{{item.no}}</span> / <span class="txt-green">{{item.yes}}</span> ）</p>
        </div>
      </el-col>
      <el-col :span="2"
              :sm="3"
              :xs="12">
        <p class="item-title">楼层</p>
        <div class="floor-item"
             v-for="(item, index) in floorData"
             :key="index"
             :class="getFloorClass(item, index)"
             @click="changeFloor(item, index)">
          <p :title="item.name"><i class="el-icon-location-information mr-5"></i>{{item.name}}</p>
          <p :title="item.no + '/' + item.yes">
            （ <span class="txt-red">{{item.no}}</span> / <span class="txt-green">{{item.yes}}</span> ）</p>
        </div>
      </el-col>
      <el-col :span="19"
              :sm="18"
              :xs="24">
        <p class="item-title">寝室监控</p>
        <el-row :gutter="10">
          <el-col :span="3"
                  :sm="6"
                  :xs="24"
                  v-for="(item, index) in roomData"
                  :key="index">
            <div class="room-item"
                 :class="item.yes !== (Number(item.yes) + Number(item.no)) ? 'bgno' : 'bgyes'">
              <div class="room-name mb-5"
                   :title="item.name"><i class="el-icon-house mr-5"></i>{{item.name}}</div>
              <div class="people-main">
                <p class="people-item"
                   v-for="(sitem, sindex) in item.child"
                   :key="sindex">
                  <el-tooltip class="item"
                              effect="dark"
                              :content="Number(sitem.yes) === 1 ? sitem.name + '：已归寝' : sitem.name + '：未归寝'"
                              placement="top">
                    <span>
                      <i class="el-icon-user mr-10"></i>
                      {{sitem.name}}
                    </span>
                  </el-tooltip>
                  <i :class="Number(sitem.yes) === 1 ? 'txt-green el-icon-check' : 'txt-red el-icon-close'"></i>
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import fetch from '@/common/api'
export default {
  data() {
    return {
      url: fetch.getWsUrl,
      websock: null,
      ip: '',
      dormitoryData: [],
      floorData: [],
      roomData: [],
      peopleData: [],
      timer: null,
      activeIndex: 0,
      floorActive: 0
    }
  },
  computed: {
    getBuildingClass() {
      return function (data, index) {
        let activeClass = this.activeIndex === index ? 'active' : ''
        let bgClass = data.yes !== Number(data.yes) + Number(data.no) ? 'bgno' : 'bgyes'
        return activeClass + ' ' + bgClass
      }
    },
    getFloorClass() {
      return function (data, index) {
        let activeClass = this.floorActive === index ? 'active' : ''
        let bgClass = data.yes !== Number(data.yes) + Number(data.no) ? 'bgno' : 'bgyes'
        return activeClass + ' ' + bgClass
      }
    }
  },
  created() {
    this.initWebSocket()
  },
  beforeDestroy() {
    this.websocketclose()
  },
  methods: {
    initWebSocket() {
      this.websock = new WebSocket('ws://' + this.url)
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onmessage = this.websocketonmessage
      this.websock.onclose = this.websocketclose
      window.onbeforeunload = this.websocketclose
    },
    websocketonopen() {
      this.websock.send('return')
      this.timer = setInterval(() => {
        this.websock.send('return')
      }, 10000)
    },
    websocketonerror() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      console.log('WebSocket连接发生错误')
      // this.$message.error('WebSocket连接发生错误')
    },
    websocketonmessage(e) {
      let data = JSON.parse(e.data)
      this.dormitoryData = data.data
      if (data.data) {
        let tmpData = []
        let tmpIndex = ''
        if (this.activeIndex) {
          tmpData = data.data[this.activeIndex]
          tmpIndex = this.activeIndex
        } else {
          let kaysArr = Object.keys(data.data)
          tmpData = data.data[kaysArr[0]]
          tmpIndex = kaysArr[0]
        }
        this.changeBuilding(tmpData, tmpIndex)
        // let floorKeysArr = Object.keys(data.data[kaysArr[0]].child)
        // this.changeFloor(data.data[kaysArr[0]].child[floorKeysArr[0]], floorKeysArr[0])
      }
    },
    websocketclose() {
      clearInterval(this.timer)
      if (this.websock) {
        this.websock.close()
      }
    },
    changeBuilding(data, index) {
      this.activeIndex = Number(index)
      this.floorData = data.child
      let tmpData = []
      let tmpIndex = ''
      if (this.floorActive) {
        tmpData = data.child[this.floorActive]
        tmpIndex = this.floorActive
      } else {
        let floorKeysArr = Object.keys(data.child)
        tmpData = data.child[floorKeysArr[0]]
        tmpIndex = floorKeysArr[0]
      }
      this.changeFloor(tmpData, tmpIndex)
    },
    changeFloor(data, index) {
      this.floorActive = Number(index)
      this.roomData = data.child
    }
  }
}
</script>

<style lang="less" scoped>
.dormitory-main {
  line-height: 20px;
  font-size: 14px;
  .building-main {
    .building-item {
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 10px;
      cursor: pointer;
      line-height: 24px;
      border-right: 3px solid #ebeef5;
      &:hover {
        border-right-color: rgba(64, 158, 255, 0.6);
      }
      &.active {
        border-right-color: rgba(64, 158, 255, 1);
      }
    }
  }
  .floor-item {
    cursor: pointer;
    box-sizing: border-box;
    line-height: 24px;
    padding: 10px;
    border-right: 3px solid transparent;
    &:hover {
      border-right-color: rgba(64, 158, 255, 0.6);
    }
    &.active {
      border-right-color: rgba(64, 158, 255, 1);
    }
    p {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .room-item {
    // min-height: 220px;
    line-height: 28px;
    padding: 10px 15px;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    margin-bottom: 10px;
    .room-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-bottom: 5px;
      border-bottom: 1px solid #ebeef5;
    }
    .people-item {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      justify-content: space-between;
    }
  }
  .txt-red {
    color: #f56c6c;
  }
  .txt-green {
    color: #67c23a;
  }
  .bgno {
    background: #fef0f0;
  }
  .bgyes {
    background: #f0f9eb;
  }
}
</style>